import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import student_Store from "../store/student_store";
import supervisor_Store from "../store/supervisor_store";
import admin_Store from "../store/admin_store";
import major_Store from "../store/major_store";
import ExportCSV from "../functions/ExportCSV";
import YesNoAsk_Modal from "../component/YesNoAsk_Modal";
import Manage_Major_Modal from "../component/Manage_Major_Modal";
import CurrUser from "../functions/UserAuth";
import { toast } from "react-toastify";
import styles from "../css/styles.module.css";

function Major_Page() {
  //#region stores
  // Student Store
  const student = student_Store((state) => state.student);
  // Supervisor Store
  const supervisor = supervisor_Store((state) => state.supervisor);
  // Admin Store
  const admin = admin_Store((state) => state.admin);
  // Major store
  const majors = major_Store((state) => state.majors);
  // all majors
  const getmajors = major_Store((state) => state.getMajors);
  // add major
  const addMajor = major_Store((state) => state.addMajor);
  // edit major
  const editMajor = major_Store((state) => state.editMajor);
  // delete major
  const deleteMajor = major_Store((state) => state.deleteMajor);
  //#endregion

  // //  let [selectValue, setSelectValue]= useState([])
  // function onSelect(actionId, id, setStatus, setClasss) {
  //   setStatus(actionId)
  //   let classvalue = actionId == 'Activated' ? 'success' : actionId == 'Deactivated' ? 'danger' : 'warning'
  //   setClasss(classvalue)
  //   putmajor({ status: actionId }, id, currentUser?.token)
  //   //   setClasss(classvalue)
  // }

  //#region variables
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const currentUser = CurrUser(student, supervisor, admin);
  // major name input
  let [name, setName] = useState("");

  // major main course  input
  let [maxMainCourse, setMaxMainCourse] = useState();

  // major alternative course  input
  let [maxAlternativeCourse, setMaxAlternativeCourse] = useState();

  // major id
  let [id, setId] = useState(-1);

  // Add & Edit modal control
  const [isAdd, setIsAdd] = useState(false);

  // for holding data while search
  let [mydata, setMydata] = useState([]);

  // page for pagination
  const [page, setPage] = useState(1);
  // page for pagination
  const [perPage, setPerPage] = useState(10);

  //#endregion variables

  //#region functions

  // edit major
  const edit = (id) => {
    setId(id);
    const result = majors?.data?.find((major) => major.id === id);
    setName(result?.name);
    setMaxMainCourse(result?.maxMainCourse);
    setMaxAlternativeCourse(result?.maxAlternativeCourse);
    setIsAdd(true);
  };
  // add major
  const add = (id) => {
    setId(-1);
    setName("");
    setIsAdd(true);
  };
  // page pagination
  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
  };

  // page pagination
  const handlePageChange = (page) => {
    setPage(page);
  };
  // page pagination
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  // searching data
  function onChange(e) {
    let word = e.target.value;
    const result = majors.data.filter(
      (major) =>
        (major.name && major.name.toLowerCase().includes(word.toLowerCase())) ||
        major?.id == word
    );
    setMydata(result);

    if (word === "") {
      setMydata([]);
      setResetPaginationToggle(!resetPaginationToggle);
    }
  }

  // CSV Export
  function exportTable() {
    let arr = mydata.length > 0 ? mydata : majors.data;
    arr.forEach((obj, index) => (obj.id = index + 1));
    arr.forEach(
      (obj) =>
        (obj.created_at =
          new Date(obj?.created_at ?? "")
            ?.toLocaleString()
            ?.replace(",", "-") ?? "")
    );
    arr.forEach((obj) => delete obj.student);
    ExportCSV(arr, "majors");
  }

  //#endregion functions

  //#region constructor
  useEffect(() => {
    getmajors(currentUser?.token);
  }, []);

  //#endregion constructor

  //#region Datatable column

  // selectors name should be same as in the database
  const columns = [
    {
      name: "ID",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "70px",
      id: 1,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      id: 2,
    },
    {
      name: "Max main courses",
      selector: (row) => row.maxMainCourse,
      sortable: true,
      id: 3,
      width: "200px",
    },
    {
      name: "Max alternative courses",
      selector: (row) => row.maxAlternativeCourse,
      sortable: true,
      width: "200px",
      id: 4,
    },

    {
      name: "Edit",
      cell: (row) => {
        return (
          <button
            onClick={function () {
              edit(row.id);
            }}
            className="btn text-white bg-primary btn-md"
            type="button"
          >
            <i class="bi bi-pencil"></i>
          </button>
        );
      },
      width: "60px",
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      name: "Delete",
      cell: (row) => {
        return (
          <button
            onClick={function () {
              handleShow();
              setId(row.id);
            }}
            className="btn text-white bg-danger btn-md"
            type="button"
          >
            <i class="bi bi-trash-fill"></i>
          </button>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
    },
    // {
    //   name: "Status",
    //   cell: (row) => {
    //     let classs = row.status == 'Pending' ? 'warning' : row.status == 'Activated' ? 'success' : 'danger';
    //     const status = row.status
    //     return <Selector_Component classs={classs} row={row} onSelect={onSelect} status={status} />
    //   }
    //   ,
    //   ignoreRowClick: true,
    //   allowOverflow: true,

    //   // button: true,
    // },
  ];
  //#endregion table column

  //#region render
  const bodyMessage =
    "Do you really want to delete? This process cannot be undone.";

  const deleteItem = async () => {
    try {
      // check and validation for name existence
      const result = await deleteMajor(id);
      // success toast appear if we succeed
      if (result?.status == 200 || result?.status == 201) {
        let msg = "Major deleted successfully";
        toast.success(msg);
        // disappear modal
        handleClose();
        setShow(false);
        setIsAdd(false);
      }
    } catch (error) {
      const errmsg = error.response?.data?.message;
      if (!errmsg) return;
      // show error reason as an error toast
      if (Array.isArray(errmsg)) {
        errmsg.forEach((element, index) => {
          setTimeout(function () {
            toast.error(element);
          }, 200 * index);
        });
      } else {
        toast.error(errmsg);
      }
    }
  };

  return (
    <>
      <div className="row justify-content-between">
        <div className="col-4"></div>
        <div className="col-1"></div>
      </div>

      <div className="d-flex bd-highlight">
        <div className="pt-2 flex-grow-1 bd-highlight">
          <input
            type="text"
            onChange={(e) => onChange(e)}
            className="form-control w-50"
            placeholder="Search.."
            required
            aria-label=""
            aria-describedby="basic-addon1"
          />
        </div>
        <div className="p-2 bd-highlight  ">
          <button
            onClick={function () {
              add();
            }}
            className="btn text-white bg-primary btn-md col-12"
            type="button"
          >
            <i className="bi bi-plus-lg" aria-hidden="true"></i>
          </button>
        </div>
        <div className="p-2 bd-highlight">
          <button
            onClick={function () {
              exportTable();
            }}
            className="btn   btn-md btn btn-outline-primary"
            type="button"
          >
            CSV
          </button>
        </div>
      </div>

      {/* Datatable */}
      <DataTable
        title="Majors"
        columns={columns}
        data={mydata?.length > 0 ? mydata : majors.data}
        progressPending={false}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        paginationTotalRows={
          mydata?.length > 0 ? mydata?.length : majors?.data?.length
        }
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pointerOnHover
        highlightOnHover
      />

      {/* Add & Edit Modal  */}
      <Manage_Major_Modal
        setIsAdd={setIsAdd}
        isOpen={isAdd}
        id={id}
        addData={addMajor}
        editData={editMajor}
        token={currentUser?.token}
        name={name}
        setName={setName}
        maxMainCourse={maxMainCourse}
        setMaxMainCourse={setMaxMainCourse}
        maxAlternativeCourse={maxAlternativeCourse}
        setMaxAlternativeCourse={setMaxAlternativeCourse}
      />

      {/* Delete Modal  */}
      <YesNoAsk_Modal
        title={"Are you sure?"}
        btnName={"Delete"}
        bodyMessage={bodyMessage}
        responseMessage={"Delete"}
        variant={"danger"}
        handleClose={handleClose}
        show={show}
        submitFunc={async function () {
          deleteItem();
        }}
      />
    </>
  );
  //#endregion render
}

export default Major_Page;
